import { doc, getDoc, serverTimestamp, updateDoc } from "firebase/firestore";
import { omit } from "lodash";
import { db } from "shared/api/firebase";
import { Game, GameToUpdate } from "../types";
import { GameDB } from "./Games";
import { saveGameImages } from "./saveGameImages";

export const updateGameDetails = async (
  gameId: string,
  game: GameToUpdate,
): Promise<Game> => {
  const fieldsToOmit = ["logoImage", "bgImage"];
  const gameDocRef = doc(db, "games", gameId);

  try {
    // Update the document with omitted image fields
    await updateDoc(gameDocRef, {
      ...omit(game, fieldsToOmit),
      updatedAt: serverTimestamp(),
    });

    // Prepare image update promises
    const imageUpdatePromises = [];
    if (game.logoImage instanceof File) {
      imageUpdatePromises.push(
        saveGameImages({
          gameId,
          keyImage: "logoImage",
          imagesFile: game.logoImage,
        }),
      );
    }
    if (game.bgImage instanceof File) {
      imageUpdatePromises.push(
        saveGameImages({
          gameId,
          keyImage: "bgImage",
          imagesFile: game.bgImage,
        }),
      );
    }

    // Execute all image update promises in parallel
    await Promise.all(imageUpdatePromises);

    // Retrieve the updated game document
    const updatedGameSnapshot = await getDoc(gameDocRef);
    return new GameDB(updatedGameSnapshot).toGame();
  } catch (error) {
    console.error("Failed to update the game:", error);
    throw error; // Rethrow or handle as needed
  }
};
